import {cyan, yellow} from '@material-ui/core/colors';
import { createTheme } from '@material-ui/core/styles';


const customTheme = createTheme({
    typography: {
        letterSpacing: 10,
        fontFamily: [                        
            '微軟正黑體',
            'Arial',
            'sans-serif'
        ].join(','),      
    },
    palette: {
        primary: {
            main: cyan[200],
        },
        secondary: {
            main: yellow[50],
        },
    },
});

export default customTheme
